import { Request } from 'api';
import { AxiosResponse } from 'axios';

type ReturnType = Promise<AxiosResponse<void>>;

const removeSharedUserForMovement = (id: string, userId: string): ReturnType => {
    return Request.delete(`/workouts/movements/${id}/users/${userId}`);
};

export default removeSharedUserForMovement;
